import React from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useOpenAlertCount } from '../useMonitoring';

/** Where the badge sends you: the monitoring page, already filtered to open alerts */
export const OPEN_ALERTS_HREF = '/monitoring?tab=alerts&status=open';

/**
 * Open early warnings, in the app header. The count is polled once a minute and
 * on window focus by a single shared timer (see `useOpenAlertCount`).
 */
export const AlertBadge: React.FC<{ className?: string; size?: 'sm' | 'lg' }> = ({ className = '', size = 'sm' }) => {
  const count = useOpenAlertCount();
  const label = count === 0 ? 'No open alerts' : `${count} open alert${count === 1 ? '' : 's'}`;

  return (
    <Link
      to={OPEN_ALERTS_HREF}
      aria-label={label}
      title={label}
      className={`relative inline-flex flex-shrink-0 items-center justify-center rounded-full text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/40 ${
        size === 'lg' ? 'h-11 w-11' : 'h-9 w-9'
      } ${className}`}
    >
      <Bell className={size === 'lg' ? 'h-[22px] w-[22px]' : 'h-[18px] w-[18px]'} strokeWidth={1.75} />
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary-600 px-1 text-[10px] font-medium leading-none text-white"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
};
